// extracted by mini-css-extract-plugin
export default {"recos":"Z6-z","productCardOverride":"_6-z","rowHasBadge":"a7-z"};